import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchFaq = createAsyncThunk('faqSlice/fetchFaq', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?faq`)
    const data = await res.json()
    return data;
})

const faqSlice = createSlice({
    initialState: {
        faq: [],
        loading: false,
        error: null,
    },
    name: 'faqSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchFaq.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFaq.fulfilled, (state, action) => {
                state.loading = false;
                state.faq = action.payload;
            })
            .addCase(fetchFaq.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = faqSlice.actions;

export default faqSlice.reducer;